define([
	"dojo/_base/declare",
	"csi/action/ManageController",
	"csi/xml"
], function(declare,ManageController,xml) {

	return declare(ManageController, {
		toWriter: function() {
			// summary: write special request to create/delete image labels
			this.m_writer.callMethod("Reflection", this.m_bToggle ? "RemoveImageLabels" : "CreateImageLabels")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlParent);
		}
	});
});